// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Role$ReactHooksTemplate = require("../settings/role.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var EmailFromId$ReactHooksTemplate = require("../surveys/emailFromId.res.js");
var Organization$ReactHooksTemplate = require("../settings/organization.res.js");
var ReportAutomailer$ReactHooksTemplate = require("./reportAutomailer.res.js");
var MultipleSelectBox$ReactHooksTemplate = require("../common/MultipleSelectBox.res.js");
var PlaceholderEditor$ReactHooksTemplate = require("./PlaceholderEditor.res.js");
var CurrentOrganization$ReactHooksTemplate = require("../CurrentOrganization.res.js");

function ReportAutomailerModal(props) {
  var __nameTakenError = props.nameTakenError;
  var __validationErrors = props.validationErrors;
  var fixedReport = props.fixedReport;
  var onClose = props.onClose;
  var onSubmit = props.onSubmit;
  var onUpdate = props.onUpdate;
  var isFormValid = props.isFormValid;
  var placeholderChips = props.placeholderChips;
  var reportOptions = props.reportOptions;
  var fromIds = props.fromIds;
  var config = props.config;
  var show = props.show;
  var validationErrors = __validationErrors !== undefined ? __validationErrors : /* [] */0;
  var nameTakenError = __nameTakenError !== undefined ? __nameTakenError : "";
  var weekdayOptions = {
    hd: [
      "monday",
      "Monday"
    ],
    tl: {
      hd: [
        "tuesday",
        "Tuesday"
      ],
      tl: {
        hd: [
          "wednesday",
          "Wednesday"
        ],
        tl: {
          hd: [
            "thursday",
            "Thursday"
          ],
          tl: {
            hd: [
              "friday",
              "Friday"
            ],
            tl: {
              hd: [
                "saturday",
                "Saturday"
              ],
              tl: {
                hd: [
                  "sunday",
                  "Sunday"
                ],
                tl: /* [] */0
              }
            }
          }
        }
      }
    }
  };
  var inputBase = "w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition duration-150";
  var labelBase = "block text-sm font-medium text-gray-700 mb-1.5";
  var fieldBlock = "flex flex-col justify-start h-full";
  var match = React.useContext(CurrentOrganization$ReactHooksTemplate.authContext);
  var match$1 = React.useState(function (param) {
        return "subject";
      });
  var setActiveContentField = match$1[1];
  var activeContentField = match$1[0];
  var match$2 = React.useState(function (param) {
        return "Edit";
      });
  var setContentMode = match$2[1];
  var contentMode = match$2[0];
  var match$3 = React.useState(function (param) {
        return "NotAvailable";
      });
  var setContentPreview = match$3[1];
  var contentPreview = match$3[0];
  var subjectEditorRef = React.useRef(null);
  var bodyEditorRef = React.useRef(null);
  var organizationTimeZone = Organization$ReactHooksTemplate.timeZone(match[0]);
  React.useEffect((function (param) {
          if (!show) {
            Curry._1(setContentMode, (function (param) {
                    return "Edit";
                  }));
            Curry._1(setContentPreview, (function (param) {
                    return "NotAvailable";
                  }));
          }
          
        }), [show]);
  var recurrence = ReportAutomailer$ReactHooksTemplate.recurrence(config);
  var __x = ReportAutomailer$ReactHooksTemplate.recurrenceSummary(config);
  var summaryText = Belt_Option.getWithDefault(__x, ReportAutomailer$ReactHooksTemplate.previewSummary(recurrence, ReportAutomailer$ReactHooksTemplate.sendTime(config), organizationTimeZone));
  var handleFromSelect = function (fromEmailId) {
    var newFrom = ReportAutomailer$ReactHooksTemplate.fromEmail(config) === fromEmailId ? "" : fromEmailId;
    Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setFromEmail(config, newFrom));
  };
  var handleToToggle = function (option) {
    var current = ReportAutomailer$ReactHooksTemplate.toEmails(config);
    var updated = Belt_List.some(current, (function (x) {
            return x === option;
          })) ? Belt_List.keep(current, (function (x) {
              return x !== option;
            })) : Belt_List.add(current, option);
    Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setToEmails(config, updated));
  };
  var handleCcToggle = function (option) {
    var current = ReportAutomailer$ReactHooksTemplate.ccEmails(config);
    var updated = Belt_List.some(current, (function (x) {
            return x === option;
          })) ? Belt_List.keep(current, (function (x) {
              return x !== option;
            })) : Belt_List.add(current, option);
    Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setCcEmails(config, updated));
  };
  var handleBccToggle = function (option) {
    var current = ReportAutomailer$ReactHooksTemplate.bccEmails(config);
    var updated = Belt_List.some(current, (function (x) {
            return x === option;
          })) ? Belt_List.keep(current, (function (x) {
              return x !== option;
            })) : Belt_List.add(current, option);
    Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setBccEmails(config, updated));
  };
  var handleRecipientRoleToggle = function (roleName) {
    var current = Belt_Option.getWithDefault(ReportAutomailer$ReactHooksTemplate.recipientRoleNames(config), /* [] */0);
    var updated = Belt_List.some(current, (function (x) {
            return x === roleName;
          })) ? Belt_List.keep(current, (function (x) {
              return x !== roleName;
            })) : Belt_List.add(current, roleName);
    Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecipientRoleNames(config, updated));
  };
  var handleReportToggle = function (reportName) {
    var report = Belt_List.getBy(reportOptions, (function (r) {
            return r.name === reportName;
          }));
    if (report === undefined) {
      return ;
    }
    var current = ReportAutomailer$ReactHooksTemplate.reportIds(config);
    var updated = Belt_List.some(current, (function (id) {
            return id === report.id;
          })) ? Belt_List.keep(current, (function (id) {
              return id !== report.id;
            })) : Belt_List.add(current, report.id);
    Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setReportIds(config, updated));
  };
  var selectedReportNames = Belt_List.keepMap(ReportAutomailer$ReactHooksTemplate.reportIds(config), (function (id) {
          var __x = Belt_List.getBy(reportOptions, (function (r) {
                  return r.id === id;
                }));
          return Belt_Option.map(__x, (function (r) {
                        return r.name;
                      }));
        }));
  var selectedTimeFrames = Belt_List.keepMap(ReportAutomailer$ReactHooksTemplate.reportIds(config), (function (id) {
          return Belt_Option.flatMap(Belt_List.getBy(reportOptions, (function (r) {
                            return r.id === id;
                          })), ReportAutomailer$ReactHooksTemplate.reportOptionTimeFrame);
        }));
  var uniqueTimeFrames = Belt_List.reduce(selectedTimeFrames, /* [] */0, (function (acc, timeFrame) {
          if (Belt_List.some(acc, (function (existing) {
                    return existing === timeFrame;
                  }))) {
            return acc;
          } else {
            return {
                    hd: timeFrame,
                    tl: acc
                  };
          }
        }));
  var hasMixedTimeFrames = Belt_List.length(uniqueTimeFrames) > 1;
  var previewSubject = ReportAutomailer$ReactHooksTemplate.subject(config);
  var previewBody = Belt_Option.getWithDefault(ReportAutomailer$ReactHooksTemplate.body(config), "");
  var placeholderChipButtons = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
                children: "Insert a placeholder into the focused field. Values are filled when the email is sent, using the report's time range (organization timezone).",
                className: "text-xs text-gray-500 mb-2"
              }),
          JsxRuntime.jsx("div", {
                children: $$Array.of_list(Belt_List.map(placeholderChips, (function (chip) {
                            return JsxRuntime.jsx("button", {
                                        children: chip.token,
                                        className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded hover:bg-blue-100",
                                        title: "Example: " + chip.example,
                                        type: "button",
                                        onClick: (function (param) {
                                            var token = chip.token;
                                            if (activeContentField === "body") {
                                              var current = Belt_Option.getWithDefault(ReportAutomailer$ReactHooksTemplate.body(config), "");
                                              var nextValue = PlaceholderEditor$ReactHooksTemplate.insertPlaceholder(bodyEditorRef, current, token, placeholderChips, true);
                                              return Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setBody(config, nextValue));
                                            }
                                            var current$1 = ReportAutomailer$ReactHooksTemplate.subject(config);
                                            var nextValue$1 = PlaceholderEditor$ReactHooksTemplate.insertPlaceholder(subjectEditorRef, current$1, token, placeholderChips, false);
                                            Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setSubject(config, nextValue$1));
                                          }),
                                        onMouseDown: (function ($$event) {
                                            $$event.preventDefault();
                                          })
                                      }, chip.token);
                          }))),
                className: "flex flex-wrap gap-2"
              }),
          hasMixedTimeFrames ? JsxRuntime.jsx("p", {
                  children: "Selected reports use different time ranges. Date placeholders will cover the full span from the earliest start to the latest end.",
                  className: "text-xs text-amber-700 mt-2"
                }) : null
        ],
        className: "mt-3"
      });
  var tmp;
  if (typeof contentPreview !== "object") {
    switch (contentPreview) {
      case "NotAvailable" :
          tmp = JsxRuntime.jsx("p", {
                children: "Select one or more reports to preview date-based placeholders.",
                className: "mt-3 text-sm text-gray-600"
              });
          break;
      case "Loading" :
          tmp = JsxRuntime.jsx("p", {
                children: "Updating preview…",
                className: "mt-3 text-sm text-gray-600"
              });
          break;
      case "Failed" :
          tmp = JsxRuntime.jsx("p", {
                children: "The preview could not be loaded. You can continue editing and try again.",
                className: "mt-3 text-sm text-red-700"
              });
          break;
      
    }
  } else {
    var unknownTokens = contentPreview.unknownTokens;
    var body = contentPreview.body;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                          children: "Subject",
                          className: "text-xs font-medium uppercase tracking-wide text-gray-500"
                        }),
                    JsxRuntime.jsx("p", {
                          children: contentPreview.subject,
                          className: "mt-1 text-sm text-gray-900 break-words"
                        })
                  ],
                  className: "mt-3 rounded border border-blue-100 bg-white px-3 py-2"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                          children: "Body",
                          className: "text-xs font-medium uppercase tracking-wide text-gray-500"
                        }),
                    JsxRuntime.jsx("p", {
                          children: body === "" ? "No custom email body." : body,
                          className: "mt-1 whitespace-pre-wrap text-sm text-gray-900 break-words"
                        })
                  ],
                  className: "mt-3 rounded border border-blue-100 bg-white px-3 py-2"
                }),
            Belt_List.length(unknownTokens) > 0 ? JsxRuntime.jsx("p", {
                    children: "Unknown placeholder" + (
                      Belt_List.length(unknownTokens) === 1 ? "" : "s"
                    ) + ": " + Js_array.joinWith(", ", Belt_List.toArray(unknownTokens)),
                    className: "mt-3 text-xs text-amber-800"
                  }) : null
          ]
        });
  }
  var contentPreviewPanel = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h4", {
                children: "Email preview",
                className: "text-sm font-semibold text-blue-900"
              }),
          JsxRuntime.jsx("p", {
                children: "Preview based on the selected reports' current time ranges and organization timezone.",
                className: "mt-1 text-xs text-blue-700"
              }),
          tmp
        ],
        className: "mt-4 rounded-lg border border-blue-200 bg-blue-50 p-4"
      });
  if (!show) {
    return null;
  }
  var match$4 = recurrence.preset;
  var tmp$1;
  switch (match$4) {
    case "custom" :
        var tmp$2;
        if (recurrence.frequency === "month") {
          var d = recurrence.byMonthDay;
          tmp$2 = JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("label", {
                        children: "On day",
                        className: labelBase,
                        htmlFor: "custom-day-of-month"
                      }),
                  JsxRuntime.jsx("input", {
                        className: inputBase,
                        id: "custom-day-of-month",
                        max: "31",
                        min: "1",
                        type: "number",
                        value: d !== undefined ? String(d) : "",
                        onChange: (function (e) {
                            var raw = e.target.value;
                            var parsed = Belt_Int.fromString(raw);
                            var value = parsed !== undefined && !(parsed < 1 || parsed > 31) ? parsed : undefined;
                            Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, {
                                      preset: recurrence.preset,
                                      frequency: recurrence.frequency,
                                      interval: recurrence.interval,
                                      byDay: recurrence.byDay,
                                      byMonthDay: value,
                                      ends: recurrence.ends
                                    }));
                          })
                      })
                ]
              });
        } else {
          tmp$2 = null;
        }
        var count = recurrence.ends.count;
        tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Repeat every",
                              className: labelBase,
                              htmlFor: "custom-interval"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("input", {
                                      className: "w-20 flex-shrink-0 border border-gray-300 rounded-l-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition duration-150 border-r-0",
                                      id: "custom-interval",
                                      max: "99",
                                      min: "1",
                                      type: "number",
                                      value: String(recurrence.interval),
                                      onChange: (function (e) {
                                          var raw = e.target.value;
                                          var parsed = Belt_Option.getWithDefault(Belt_Int.fromString(raw), 1);
                                          var interval = parsed < 1 ? 1 : (
                                              parsed > 99 ? 99 : parsed
                                            );
                                          Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, {
                                                    preset: recurrence.preset,
                                                    frequency: recurrence.frequency,
                                                    interval: interval,
                                                    byDay: recurrence.byDay,
                                                    byMonthDay: recurrence.byMonthDay,
                                                    ends: recurrence.ends
                                                  }));
                                        })
                                    }),
                                JsxRuntime.jsxs("select", {
                                      children: [
                                        JsxRuntime.jsx("option", {
                                              children: "day(s)",
                                              value: "day"
                                            }),
                                        JsxRuntime.jsx("option", {
                                              children: "week(s)",
                                              value: "week"
                                            }),
                                        JsxRuntime.jsx("option", {
                                              children: "month(s)",
                                              value: "month"
                                            })
                                      ],
                                      "aria-label": "Repeat unit",
                                      className: "flex-1 min-w-0 border border-gray-300 rounded-r-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition duration-150 cursor-pointer bg-white",
                                      id: "custom-frequency-unit",
                                      value: recurrence.frequency,
                                      onChange: (function (e) {
                                          var value = e.target.value;
                                          var nextRecurrence_preset = recurrence.preset;
                                          var nextRecurrence_interval = recurrence.interval;
                                          var nextRecurrence_byDay = value === "week" && Belt_List.length(recurrence.byDay) === 0 ? ({
                                                hd: "monday",
                                                tl: /* [] */0
                                              }) : recurrence.byDay;
                                          var nextRecurrence_byMonthDay = value === "month" ? 1 : undefined;
                                          var nextRecurrence_ends = recurrence.ends;
                                          var nextRecurrence = {
                                            preset: nextRecurrence_preset,
                                            frequency: value,
                                            interval: nextRecurrence_interval,
                                            byDay: nextRecurrence_byDay,
                                            byMonthDay: nextRecurrence_byMonthDay,
                                            ends: nextRecurrence_ends
                                          };
                                          Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, nextRecurrence));
                                        })
                                    })
                              ],
                              className: "flex items-stretch w-full max-w-xs"
                            })
                      ]
                    }),
                recurrence.frequency === "week" ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("label", {
                                children: "Repeat on",
                                className: labelBase
                              }),
                          JsxRuntime.jsx("div", {
                                children: $$Array.of_list(Belt_List.map(weekdayOptions, (function (param) {
                                            var value = param[0];
                                            var selected = Belt_List.some(recurrence.byDay, (function (day) {
                                                    return day === value;
                                                  }));
                                            return JsxRuntime.jsx("button", {
                                                        children: param[1],
                                                        className: "px-3 py-1.5 rounded-md text-xs font-medium border " + (
                                                          selected ? "bg-blue-600 text-white border-blue-600" : "bg-white text-gray-700 border-gray-300"
                                                        ),
                                                        type: "button",
                                                        onClick: (function (param) {
                                                            var nextRecurrence = ReportAutomailer$ReactHooksTemplate.toggleByDay(recurrence, value);
                                                            Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, nextRecurrence));
                                                          })
                                                      }, value);
                                          }))),
                                className: "flex flex-wrap gap-2"
                              }),
                          JsxRuntime.jsx("button", {
                                children: "Weekdays (Mon–Fri)",
                                className: "mt-2 text-xs text-blue-600 hover:underline",
                                type: "button",
                                onClick: (function (param) {
                                    Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, {
                                              preset: recurrence.preset,
                                              frequency: recurrence.frequency,
                                              interval: recurrence.interval,
                                              byDay: {
                                                hd: "monday",
                                                tl: {
                                                  hd: "tuesday",
                                                  tl: {
                                                    hd: "wednesday",
                                                    tl: {
                                                      hd: "thursday",
                                                      tl: {
                                                        hd: "friday",
                                                        tl: /* [] */0
                                                      }
                                                    }
                                                  }
                                                }
                                              },
                                              byMonthDay: recurrence.byMonthDay,
                                              ends: recurrence.ends
                                            }));
                                  })
                              })
                        ],
                        className: "sm:col-span-2"
                      }) : null,
                tmp$2,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Ends",
                              className: labelBase
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("label", {
                                      children: [
                                        JsxRuntime.jsx("input", {
                                              checked: recurrence.ends.type_ === "never",
                                              name: "recurrence-ends",
                                              type: "radio",
                                              onChange: (function (param) {
                                                  Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, {
                                                            preset: recurrence.preset,
                                                            frequency: recurrence.frequency,
                                                            interval: recurrence.interval,
                                                            byDay: recurrence.byDay,
                                                            byMonthDay: recurrence.byMonthDay,
                                                            ends: {
                                                              type_: "never",
                                                              count: undefined,
                                                              date: undefined
                                                            }
                                                          }));
                                                })
                                            }),
                                        "Never"
                                      ],
                                      className: "flex items-center gap-2 text-sm text-gray-700"
                                    }),
                                JsxRuntime.jsxs("label", {
                                      children: [
                                        JsxRuntime.jsx("input", {
                                              checked: recurrence.ends.type_ === "after",
                                              name: "recurrence-ends",
                                              type: "radio",
                                              onChange: (function (param) {
                                                  Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, {
                                                            preset: recurrence.preset,
                                                            frequency: recurrence.frequency,
                                                            interval: recurrence.interval,
                                                            byDay: recurrence.byDay,
                                                            byMonthDay: recurrence.byMonthDay,
                                                            ends: {
                                                              type_: "after",
                                                              count: 12,
                                                              date: undefined
                                                            }
                                                          }));
                                                })
                                            }),
                                        "After",
                                        JsxRuntime.jsx("input", {
                                              className: "w-20 border border-gray-300 rounded px-2 py-1 text-sm",
                                              max: "999",
                                              min: "1",
                                              type: "number",
                                              value: count !== undefined ? String(count) : "",
                                              onChange: (function (e) {
                                                  var raw = e.target.value;
                                                  var parsed = Belt_Option.getWithDefault(Belt_Int.fromString(raw), 12);
                                                  Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, {
                                                            preset: recurrence.preset,
                                                            frequency: recurrence.frequency,
                                                            interval: recurrence.interval,
                                                            byDay: recurrence.byDay,
                                                            byMonthDay: recurrence.byMonthDay,
                                                            ends: {
                                                              type_: "after",
                                                              count: parsed,
                                                              date: undefined
                                                            }
                                                          }));
                                                })
                                            }),
                                        "occurrences"
                                      ],
                                      className: "flex items-center gap-2 text-sm text-gray-700"
                                    }),
                                JsxRuntime.jsxs("label", {
                                      children: [
                                        JsxRuntime.jsx("input", {
                                              checked: recurrence.ends.type_ === "on",
                                              name: "recurrence-ends",
                                              type: "radio",
                                              onChange: (function (param) {
                                                  Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, {
                                                            preset: recurrence.preset,
                                                            frequency: recurrence.frequency,
                                                            interval: recurrence.interval,
                                                            byDay: recurrence.byDay,
                                                            byMonthDay: recurrence.byMonthDay,
                                                            ends: {
                                                              type_: "on",
                                                              count: undefined,
                                                              date: ""
                                                            }
                                                          }));
                                                })
                                            }),
                                        "On",
                                        JsxRuntime.jsx("input", {
                                              className: "border border-gray-300 rounded px-2 py-1 text-sm",
                                              type: "date",
                                              value: Belt_Option.getWithDefault(recurrence.ends.date, ""),
                                              onChange: (function (e) {
                                                  var value = e.target.value;
                                                  var nextRecurrence_preset = recurrence.preset;
                                                  var nextRecurrence_frequency = recurrence.frequency;
                                                  var nextRecurrence_interval = recurrence.interval;
                                                  var nextRecurrence_byDay = recurrence.byDay;
                                                  var nextRecurrence_byMonthDay = recurrence.byMonthDay;
                                                  var nextRecurrence_ends = {
                                                    type_: "on",
                                                    count: undefined,
                                                    date: value === "" ? undefined : value
                                                  };
                                                  var nextRecurrence = {
                                                    preset: nextRecurrence_preset,
                                                    frequency: nextRecurrence_frequency,
                                                    interval: nextRecurrence_interval,
                                                    byDay: nextRecurrence_byDay,
                                                    byMonthDay: nextRecurrence_byMonthDay,
                                                    ends: nextRecurrence_ends
                                                  };
                                                  Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, nextRecurrence));
                                                })
                                            })
                                      ],
                                      className: "flex items-center gap-2 text-sm text-gray-700"
                                    })
                              ],
                              className: "space-y-2"
                            })
                      ],
                      className: "sm:col-span-2"
                    })
              ]
            });
        break;
    case "monthly" :
        var d$1 = recurrence.byMonthDay;
        tmp$1 = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("label", {
                      children: [
                        "Day of month",
                        JsxRuntime.jsx("span", {
                              children: "(required)",
                              className: "text-red-500 font-normal ml-1"
                            })
                      ],
                      className: labelBase,
                      htmlFor: "day-of-month"
                    }),
                JsxRuntime.jsx("input", {
                      className: inputBase,
                      id: "day-of-month",
                      max: "31",
                      min: "1",
                      type: "number",
                      value: d$1 !== undefined ? String(d$1) : "",
                      onChange: (function (e) {
                          var raw = e.target.value;
                          var parsed = Belt_Int.fromString(raw);
                          var value = parsed !== undefined && !(parsed < 1 || parsed > 31) ? parsed : undefined;
                          Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, {
                                    preset: recurrence.preset,
                                    frequency: recurrence.frequency,
                                    interval: recurrence.interval,
                                    byDay: recurrence.byDay,
                                    byMonthDay: value,
                                    ends: recurrence.ends
                                  }));
                        })
                    }),
                JsxRuntime.jsx("p", {
                      children: "Choose 1–31.",
                      className: "text-xs text-gray-500 mt-1"
                    })
              ]
            });
        break;
    case "weekly" :
        tmp$1 = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("label", {
                      children: [
                        "Weekday",
                        JsxRuntime.jsx("span", {
                              children: "(required)",
                              className: "text-red-500 font-normal ml-1"
                            })
                      ],
                      className: labelBase,
                      htmlFor: "weekday"
                    }),
                JsxRuntime.jsxs("select", {
                      children: [
                        JsxRuntime.jsx("option", {
                              children: "Select weekday...",
                              value: ""
                            }),
                        $$Array.of_list(Belt_List.map(weekdayOptions, (function (param) {
                                    var value = param[0];
                                    return JsxRuntime.jsx("option", {
                                                children: param[1],
                                                value: value
                                              }, value);
                                  })))
                      ],
                      className: inputBase + " cursor-pointer",
                      id: "weekday",
                      value: Belt_Option.getWithDefault(ReportAutomailer$ReactHooksTemplate.weekday(config), ""),
                      onChange: (function (e) {
                          var value = e.target.value;
                          var nextRecurrence_preset = recurrence.preset;
                          var nextRecurrence_frequency = recurrence.frequency;
                          var nextRecurrence_interval = recurrence.interval;
                          var nextRecurrence_byDay = value === "" ? /* [] */0 : ({
                                hd: value,
                                tl: /* [] */0
                              });
                          var nextRecurrence_byMonthDay = recurrence.byMonthDay;
                          var nextRecurrence_ends = recurrence.ends;
                          var nextRecurrence = {
                            preset: nextRecurrence_preset,
                            frequency: nextRecurrence_frequency,
                            interval: nextRecurrence_interval,
                            byDay: nextRecurrence_byDay,
                            byMonthDay: nextRecurrence_byMonthDay,
                            ends: nextRecurrence_ends
                          };
                          Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setRecurrence(config, nextRecurrence));
                        })
                    })
              ]
            });
        break;
    default:
      tmp$1 = JsxRuntime.jsx("div", {});
  }
  var tmp$3;
  tmp$3 = contentMode === "Edit" ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("label", {
                          children: [
                            "Subject",
                            JsxRuntime.jsx("span", {
                                  children: "(required)",
                                  className: "text-red-500 font-normal ml-1"
                                })
                          ],
                          className: labelBase,
                          htmlFor: "automailer-subject"
                        }),
                    JsxRuntime.jsx(PlaceholderEditor$ReactHooksTemplate.make, {
                          id: "automailer-subject",
                          value: ReportAutomailer$ReactHooksTemplate.subject(config),
                          onChange: (function (value) {
                              Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setSubject(config, value));
                            }),
                          onFocus: (function (param) {
                              Curry._1(setActiveContentField, (function (param) {
                                      return "subject";
                                    }));
                            }),
                          editorRef: subjectEditorRef,
                          placeholder: "Email subject",
                          placeholderChips: placeholderChips
                        })
                  ]
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("label", {
                          children: [
                            "Body",
                            JsxRuntime.jsx("span", {
                                  children: "(optional – custom email content)",
                                  className: "font-normal text-gray-500"
                                })
                          ],
                          className: labelBase,
                          htmlFor: "automailer-body"
                        }),
                    JsxRuntime.jsx(PlaceholderEditor$ReactHooksTemplate.make, {
                          id: "automailer-body",
                          value: Belt_Option.getWithDefault(ReportAutomailer$ReactHooksTemplate.body(config), ""),
                          onChange: (function (value) {
                              Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setBody(config, value === "" ? undefined : value));
                            }),
                          onFocus: (function (param) {
                              Curry._1(setActiveContentField, (function (param) {
                                      return "body";
                                    }));
                            }),
                          editorRef: bodyEditorRef,
                          placeholder: "Optional message body",
                          placeholderChips: placeholderChips,
                          multiline: true
                        })
                  ]
                }),
            placeholderChipButtons
          ],
          className: "grid grid-cols-1 gap-5"
        }) : contentPreviewPanel;
  var tmp$4;
  switch (props.formAction) {
    case "create" :
        tmp$4 = "Create";
        break;
    case "update" :
        tmp$4 = "Save changes";
        break;
    default:
      tmp$4 = "Save";
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("h2", {
                                    children: ReportAutomailer$ReactHooksTemplate.name(config).length > 0 ? "Edit report automailer" : "Create report automailer",
                                    className: "text-base sm:text-lg font-bold text-gray-900 min-w-0 truncate flex-1"
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "h-4 w-4",
                                          alt: "Close",
                                          src: Image$ReactHooksTemplate.closeIcon
                                        }),
                                    "aria-label": "Close",
                                    className: "flex-shrink-0 min-w-[44px] min-h-[44px] flex items-center justify-center -m-2 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                    type: "button",
                                    onClick: (function (param) {
                                        Curry._1(onClose, undefined);
                                      })
                                  })
                            ],
                            className: "flex-none shrink-0 flex items-center justify-between gap-3 px-4 py-4 sm:px-6 sm:py-5 bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 border-b border-gray-200"
                          }),
                      Belt_List.length(validationErrors) > 0 ? JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: "Validation failed",
                                      className: "font-medium text-red-800 text-sm mb-1"
                                    }),
                                JsxRuntime.jsx("ul", {
                                      children: $$Array.of_list(Belt_List.map(validationErrors, (function (msg) {
                                                  return JsxRuntime.jsx("li", {
                                                              children: msg
                                                            }, msg);
                                                }))),
                                      className: "list-disc list-inside text-red-700 text-xs sm:text-sm"
                                    })
                              ],
                              className: "flex-none shrink-0 px-4 py-3 sm:px-6 bg-red-50 border-b border-red-200"
                            }) : null,
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("section", {
                                          children: [
                                            JsxRuntime.jsx("h3", {
                                                  children: "Basic information",
                                                  className: "text-xs font-bold text-blue-700 uppercase tracking-wider mb-4"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("label", {
                                                                  children: [
                                                                    "Name",
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "(required)",
                                                                          className: "text-red-500 font-normal ml-1"
                                                                        })
                                                                  ],
                                                                  className: labelBase,
                                                                  htmlFor: "automailer-name"
                                                                }),
                                                            JsxRuntime.jsx("input", {
                                                                  className: inputBase + (
                                                                    nameTakenError !== "" ? " border-red-500" : ""
                                                                  ),
                                                                  id: "automailer-name",
                                                                  placeholder: "e.g. Daily report digest",
                                                                  value: ReportAutomailer$ReactHooksTemplate.name(config),
                                                                  onChange: (function (e) {
                                                                      var value = e.target.value;
                                                                      Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setName(config, value));
                                                                    })
                                                                }),
                                                            nameTakenError !== "" ? JsxRuntime.jsx("p", {
                                                                    children: nameTakenError,
                                                                    className: "text-red-600 text-sm mt-1"
                                                                  }) : null
                                                          ]
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("label", {
                                                                  children: [
                                                                    "How often to send",
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "(required)",
                                                                          className: "text-red-500 font-normal ml-1"
                                                                        })
                                                                  ],
                                                                  className: labelBase,
                                                                  htmlFor: "frequency"
                                                                }),
                                                            JsxRuntime.jsxs("select", {
                                                                  children: [
                                                                    JsxRuntime.jsx("option", {
                                                                          children: "Select...",
                                                                          value: ""
                                                                        }),
                                                                    $$Array.of_list(Belt_List.map({
                                                                              hd: [
                                                                                "daily",
                                                                                "Daily"
                                                                              ],
                                                                              tl: {
                                                                                hd: [
                                                                                  "weekly",
                                                                                  "Weekly"
                                                                                ],
                                                                                tl: {
                                                                                  hd: [
                                                                                    "monthly",
                                                                                    "Monthly"
                                                                                  ],
                                                                                  tl: {
                                                                                    hd: [
                                                                                      "custom",
                                                                                      "Custom..."
                                                                                    ],
                                                                                    tl: /* [] */0
                                                                                  }
                                                                                }
                                                                              }
                                                                            }, (function (param) {
                                                                                var value = param[0];
                                                                                return JsxRuntime.jsx("option", {
                                                                                            children: param[1],
                                                                                            value: value
                                                                                          }, value);
                                                                              })))
                                                                  ],
                                                                  className: inputBase + " cursor-pointer",
                                                                  id: "frequency",
                                                                  value: recurrence.preset,
                                                                  onChange: (function (e) {
                                                                      var value = e.target.value;
                                                                      Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.applyPreset(config, value));
                                                                    })
                                                                }),
                                                            JsxRuntime.jsx("p", {
                                                                  children: "Timezone: " + organizationTimeZone,
                                                                  className: "text-xs text-gray-500 mt-1"
                                                                }),
                                                            JsxRuntime.jsx("p", {
                                                                  children: summaryText,
                                                                  className: "text-xs text-blue-700 mt-1 font-medium"
                                                                })
                                                          ]
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("label", {
                                                                  children: [
                                                                    "Send time",
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "(required)",
                                                                          className: "text-red-500 font-normal ml-1"
                                                                        })
                                                                  ],
                                                                  className: labelBase,
                                                                  htmlFor: "send-time"
                                                                }),
                                                            JsxRuntime.jsx("input", {
                                                                  className: inputBase,
                                                                  id: "send-time",
                                                                  type: "time",
                                                                  value: ReportAutomailer$ReactHooksTemplate.sendTime(config),
                                                                  onChange: (function (e) {
                                                                      var value = e.target.value;
                                                                      Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setSendTime(config, value));
                                                                    })
                                                                }),
                                                            JsxRuntime.jsx("p", {
                                                                  children: "Time is interpreted in the organization timezone.",
                                                                  className: "text-xs text-gray-500 mt-1"
                                                                })
                                                          ]
                                                        }),
                                                    tmp$1
                                                  ],
                                                  className: "grid grid-cols-1 sm:grid-cols-2 gap-5 items-start"
                                                })
                                          ],
                                          className: "pl-4 border-l-4 border-blue-500 rounded"
                                        }),
                                    JsxRuntime.jsxs("section", {
                                          children: [
                                            JsxRuntime.jsx("h3", {
                                                  children: "Report format",
                                                  className: "text-xs font-bold text-green-700 uppercase tracking-wider mb-4"
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "Choose how reports are included in the email. For each report: if it has more than the threshold rows (max 60), it is sent as an attachment; otherwise as a table in the email body.",
                                                  className: "text-sm text-gray-600 mb-4"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("label", {
                                                                  children: "Send reports as",
                                                                  className: labelBase + " sm:min-h-[72px]",
                                                                  htmlFor: "delivery-format"
                                                                }),
                                                            JsxRuntime.jsxs("select", {
                                                                  children: [
                                                                    JsxRuntime.jsx("option", {
                                                                          children: "Auto (by size)",
                                                                          value: "auto"
                                                                        }),
                                                                    JsxRuntime.jsx("option", {
                                                                          children: "Always table in email",
                                                                          value: "table"
                                                                        }),
                                                                    JsxRuntime.jsx("option", {
                                                                          children: "Always attachment",
                                                                          value: "attachment"
                                                                        })
                                                                  ],
                                                                  className: inputBase + " cursor-pointer",
                                                                  id: "delivery-format",
                                                                  value: ReportAutomailer$ReactHooksTemplate.deliveryFormat(config),
                                                                  onChange: (function (e) {
                                                                      var value = e.target.value;
                                                                      Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setDeliveryFormat(config, value));
                                                                    })
                                                                })
                                                          ],
                                                          className: fieldBlock
                                                        }),
                                                    ReportAutomailer$ReactHooksTemplate.deliveryFormat(config) === "auto" ? JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx("label", {
                                                                    children: "Max rows for table (1–60, default 60)",
                                                                    className: labelBase + " sm:min-h-[72px]",
                                                                    htmlFor: "attachment-threshold"
                                                                  }),
                                                              JsxRuntime.jsx("input", {
                                                                    className: inputBase,
                                                                    id: "attachment-threshold",
                                                                    max: "60",
                                                                    min: "1",
                                                                    type: "number",
                                                                    value: String(ReportAutomailer$ReactHooksTemplate.attachmentThresholdRows(config)),
                                                                    onChange: (function (e) {
                                                                        var raw = e.target.value;
                                                                        var parsed = Belt_Option.getWithDefault(Belt_Int.fromString(raw), 60);
                                                                        var value = parsed > 60 ? 60 : (
                                                                            parsed < 1 ? 1 : parsed
                                                                          );
                                                                        Curry._1(onUpdate, ReportAutomailer$ReactHooksTemplate.setAttachmentThresholdRows(config, value));
                                                                      })
                                                                  }),
                                                              JsxRuntime.jsx("p", {
                                                                    children: "For each report: if it has more than this many rows (max 60), it is sent as an attachment; otherwise as a table in the email body.",
                                                                    className: "text-xs text-gray-500 mt-1"
                                                                  })
                                                            ],
                                                            className: fieldBlock
                                                          }) : null
                                                  ],
                                                  className: "grid grid-cols-1 sm:grid-cols-2 gap-5 items-start"
                                                }),
                                            ReportAutomailer$ReactHooksTemplate.deliveryFormat(config) === "table" ? JsxRuntime.jsx("p", {
                                                    children: "Reports are always included as tables in the email body.",
                                                    className: "text-xs text-gray-500 mt-2"
                                                  }) : (
                                                ReportAutomailer$ReactHooksTemplate.deliveryFormat(config) === "attachment" ? JsxRuntime.jsx("p", {
                                                        children: "Reports are always sent as attachments.",
                                                        className: "text-xs text-gray-500 mt-2"
                                                      }) : null
                                              )
                                          ],
                                          className: "pl-4 border-l-4 border-green-500 rounded"
                                        }),
                                    JsxRuntime.jsxs("section", {
                                          children: [
                                            JsxRuntime.jsx("h3", {
                                                  children: "Email recipients",
                                                  className: "text-xs font-bold text-indigo-700 uppercase tracking-wider mb-4"
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "Choose from your configured sender addresses.",
                                                  className: "text-sm text-gray-600 mb-4"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("label", {
                                                                  children: [
                                                                    "From",
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "(required)",
                                                                          className: "text-red-500 font-normal ml-1"
                                                                        })
                                                                  ],
                                                                  className: labelBase
                                                                }),
                                                            JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                                  options: List.map(EmailFromId$ReactHooksTemplate.fromId, fromIds),
                                                                  placeholder: "Select sender",
                                                                  handleChange: handleFromSelect,
                                                                  selectedOptions: {
                                                                    hd: ReportAutomailer$ReactHooksTemplate.fromEmail(config),
                                                                    tl: /* [] */0
                                                                  },
                                                                  className: "w-full min-h-[40px] flex items-center border border-gray-300 rounded-lg px-4 py-2 text-sm bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500"
                                                                })
                                                          ],
                                                          className: fieldBlock
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("label", {
                                                                  children: [
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "To"
                                                                        }),
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "(required)",
                                                                          className: "text-red-500 font-normal"
                                                                        })
                                                                  ],
                                                                  className: labelBase
                                                                }),
                                                            JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                                  options: List.map(EmailFromId$ReactHooksTemplate.fromId, fromIds),
                                                                  placeholder: "Select recipients",
                                                                  handleChange: handleToToggle,
                                                                  selectedOptions: ReportAutomailer$ReactHooksTemplate.toEmails(config),
                                                                  className: "w-full min-h-[40px] flex items-center border border-gray-300 rounded-lg px-4 py-2 text-sm bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500"
                                                                })
                                                          ],
                                                          className: fieldBlock
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("label", {
                                                                  children: [
                                                                    "Add recipients by role",
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "(emails of users in selected roles)",
                                                                          className: "font-normal text-gray-500 ml-1"
                                                                        })
                                                                  ],
                                                                  className: labelBase + " sm:min-h-[72px]"
                                                                }),
                                                            JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                                  options: List.map(Role$ReactHooksTemplate.name, props.roles),
                                                                  placeholder: "Select roles",
                                                                  handleChange: handleRecipientRoleToggle,
                                                                  selectedOptions: Belt_Option.getWithDefault(ReportAutomailer$ReactHooksTemplate.recipientRoleNames(config), /* [] */0),
                                                                  className: "w-full min-h-[40px] flex items-center border border-gray-300 rounded-lg px-4 py-2 text-sm bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500"
                                                                })
                                                          ],
                                                          className: fieldBlock
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("label", {
                                                                  children: [
                                                                    "CC",
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "(optional)",
                                                                          className: "font-normal text-gray-500"
                                                                        })
                                                                  ],
                                                                  className: labelBase + " sm:min-h-[72px]"
                                                                }),
                                                            JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                                  options: List.map(EmailFromId$ReactHooksTemplate.fromId, fromIds),
                                                                  placeholder: "Select CC",
                                                                  handleChange: handleCcToggle,
                                                                  selectedOptions: ReportAutomailer$ReactHooksTemplate.ccEmails(config),
                                                                  className: "w-full min-h-[40px] flex items-center border border-gray-300 rounded-lg px-4 py-2 text-sm bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500"
                                                                })
                                                          ],
                                                          className: fieldBlock
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("label", {
                                                                  children: [
                                                                    "BCC",
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "(optional)",
                                                                          className: "font-normal text-gray-500"
                                                                        })
                                                                  ],
                                                                  className: labelBase
                                                                }),
                                                            JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                                  options: List.map(EmailFromId$ReactHooksTemplate.fromId, fromIds),
                                                                  placeholder: "Select BCC",
                                                                  handleChange: handleBccToggle,
                                                                  selectedOptions: ReportAutomailer$ReactHooksTemplate.bccEmails(config),
                                                                  className: "w-full min-h-[40px] flex items-center border border-gray-300 rounded-lg px-4 py-2 text-sm bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500"
                                                                })
                                                          ],
                                                          className: fieldBlock + " sm:col-span-2"
                                                        })
                                                  ],
                                                  className: "grid grid-cols-1 sm:grid-cols-2 gap-5 items-start auto-rows-min"
                                                })
                                          ],
                                          className: "pl-4 border-l-4 border-indigo-500 rounded"
                                        }),
                                    JsxRuntime.jsxs("section", {
                                          children: [
                                            JsxRuntime.jsx("h3", {
                                                  children: "Email content",
                                                  className: "text-xs font-bold text-amber-700 uppercase tracking-wider mb-4"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("button", {
                                                          children: "Edit",
                                                          className: "px-3 py-1.5 text-sm font-medium rounded-md transition-colors " + (
                                                            contentMode === "Edit" ? "bg-white text-amber-900 shadow-sm" : "text-amber-700 hover:text-amber-900"
                                                          ),
                                                          type: "button",
                                                          onClick: (function (param) {
                                                              Curry._1(setContentMode, (function (param) {
                                                                      return "Edit";
                                                                    }));
                                                            })
                                                        }),
                                                    JsxRuntime.jsx("button", {
                                                          children: "Preview",
                                                          className: "px-3 py-1.5 text-sm font-medium rounded-md transition-colors " + (
                                                            contentMode === "Preview" ? "bg-white text-amber-900 shadow-sm" : "text-amber-700 hover:text-amber-900"
                                                          ),
                                                          type: "button",
                                                          onClick: (function (param) {
                                                              Curry._1(setContentMode, (function (param) {
                                                                      return "Preview";
                                                                    }));
                                                              if (Belt_List.length(ReportAutomailer$ReactHooksTemplate.reportIds(config)) === 0) {
                                                                return Curry._1(setContentPreview, (function (param) {
                                                                              return "NotAvailable";
                                                                            }));
                                                              }
                                                              Curry._1(setContentPreview, (function (param) {
                                                                      return "Loading";
                                                                    }));
                                                              var params = {};
                                                              var previewParams = Json_encode.object_({
                                                                    hd: [
                                                                      "subject",
                                                                      previewSubject
                                                                    ],
                                                                    tl: {
                                                                      hd: [
                                                                        "body",
                                                                        previewBody
                                                                      ],
                                                                      tl: {
                                                                        hd: [
                                                                          "report_ids",
                                                                          Json_encode.array((function (prim) {
                                                                                  return prim;
                                                                                }), Belt_List.toArray(ReportAutomailer$ReactHooksTemplate.reportIds(config)))
                                                                        ],
                                                                        tl: /* [] */0
                                                                      }
                                                                    }
                                                                  });
                                                              params["report_automailer"] = previewParams;
                                                              Js_promise.$$catch((function (param) {
                                                                      Curry._1(setContentPreview, (function (param) {
                                                                              return "Failed";
                                                                            }));
                                                                      return Promise.resolve();
                                                                    }), Js_promise.then_((function (response) {
                                                                          var subject = Json_decode.field("data", (function (param) {
                                                                                  return Json_decode.field("rendered_subject", Json_decode.string, param);
                                                                                }), response);
                                                                          var body = Json_decode.field("data", (function (param) {
                                                                                  return Json_decode.field("rendered_body", Json_decode.string, param);
                                                                                }), response);
                                                                          var unknownTokens = Belt_List.fromArray(Json_decode.field("data", (function (param) {
                                                                                      return Json_decode.field("unknown_tokens", (function (param) {
                                                                                                    return Json_decode.array(Json_decode.string, param);
                                                                                                  }), param);
                                                                                    }), response));
                                                                          Curry._1(setContentPreview, (function (param) {
                                                                                  return {
                                                                                          TAG: "Loaded",
                                                                                          subject: subject,
                                                                                          body: body,
                                                                                          unknownTokens: unknownTokens
                                                                                        };
                                                                                }));
                                                                          return Promise.resolve();
                                                                        }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/report_automailers/preview_content", params)));
                                                            })
                                                        })
                                                  ],
                                                  className: "inline-flex rounded-lg border border-amber-200 bg-amber-50 p-1 mb-5"
                                                }),
                                            tmp$3
                                          ],
                                          className: "pl-4 border-l-4 border-amber-500 rounded"
                                        }),
                                    JsxRuntime.jsxs("section", {
                                          children: [
                                            JsxRuntime.jsx("h3", {
                                                  children: "Reports to send",
                                                  className: "text-xs font-bold text-green-700 uppercase tracking-wider mb-4"
                                                }),
                                            fixedReport !== undefined ? JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsxs("label", {
                                                            children: [
                                                              "Report",
                                                              JsxRuntime.jsx("span", {
                                                                    children: "(required)",
                                                                    className: "text-red-500 font-normal ml-1"
                                                                  })
                                                            ],
                                                            className: labelBase
                                                          }),
                                                      JsxRuntime.jsx("div", {
                                                            children: fixedReport.name,
                                                            className: "px-4 py-2 text-sm border border-gray-200 rounded-lg bg-gray-50 text-gray-800"
                                                          }),
                                                      JsxRuntime.jsx("p", {
                                                            children: "This report will be included in the email.",
                                                            className: "text-xs text-gray-500 mt-1"
                                                          })
                                                    ]
                                                  }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Select which reports to include in the email.",
                                                            className: "text-sm text-gray-600 mb-4"
                                                          }),
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsxs("label", {
                                                                    children: [
                                                                      "Reports",
                                                                      JsxRuntime.jsx("span", {
                                                                            children: "(required)",
                                                                            className: "text-red-500 font-normal ml-1"
                                                                          })
                                                                    ],
                                                                    className: labelBase
                                                                  }),
                                                              JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                                    options: List.map(ReportAutomailer$ReactHooksTemplate.reportOptionName, reportOptions),
                                                                    placeholder: "Select reports",
                                                                    handleChange: handleReportToggle,
                                                                    selectedOptions: selectedReportNames,
                                                                    className: "w-full min-h-[40px] flex items-center border border-gray-300 rounded-lg px-4 py-2 text-sm bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500"
                                                                  }),
                                                              hasMixedTimeFrames ? JsxRuntime.jsx("p", {
                                                                      children: "Selected reports use different time ranges. Date placeholders will cover the full span from the earliest start to the latest end.",
                                                                      className: "text-xs text-amber-700 mt-2"
                                                                    }) : null
                                                            ]
                                                          })
                                                    ]
                                                  })
                                          ],
                                          className: "pl-4 border-l-4 border-green-500 rounded"
                                        })
                                  ],
                                  className: "px-4 py-4 sm:px-6 sm:py-6 space-y-6 sm:space-y-8 pb-4"
                                }),
                            className: "flex-1 min-h-0 overflow-y-auto overflow-x-hidden overscroll-contain"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Cancel",
                                    className: "w-full sm:w-auto min-h-[44px] sm:min-h-0 px-6 py-3 sm:py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 sm:mr-3",
                                    type: "button",
                                    onClick: (function (param) {
                                        Curry._1(onClose, undefined);
                                      })
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: tmp$4,
                                    className: "w-full sm:w-auto min-h-[44px] sm:min-h-0 px-6 py-3 sm:py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 " + (
                                      isFormValid ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
                                    ),
                                    disabled: !isFormValid,
                                    type: "button",
                                    onClick: (function (param) {
                                        if (isFormValid) {
                                          return Curry._1(onSubmit, undefined);
                                        }
                                        
                                      })
                                  })
                            ],
                            className: "flex-none shrink-0 flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-0 mt-4 px-4 py-4 sm:p-6 sm:pt-6 border-t border-gray-200"
                          })
                    ],
                    className: "bg-white report-automailer-modal modal-data-fields z-10 shadow relative border border-gray-300 pointer-events-auto rounded-none sm:rounded-xl overflow-hidden flex flex-col w-full my-0 sm:my-4 max-w-full sm:max-w-2xl md:max-w-3xl",
                    style: {
                      height: "calc(100vh - 2rem)",
                      maxHeight: "calc(100vh - 2rem)",
                      minHeight: "20rem"
                    },
                    onClick: (function (e) {
                        e.stopPropagation();
                      })
                  }),
              className: "w-full min-h-screen z-50 disabled-wrapper fixed inset-0 flex justify-center items-start sm:items-center overflow-y-auto overflow-x-hidden p-0 sm:p-4",
              style: {
                minHeight: "100vh"
              },
              onClick: (function (param) {
                  Curry._1(onClose, undefined);
                })
            });
}

var make = ReportAutomailerModal;

exports.make = make;
/* react Not a pure module */
